import * as THREE from 'three';

export function buildBow(mats) {
  const g = new THREE.Group();
  g.name = 'bow';

  const curve = new THREE.CatmullRomCurve3([
    new THREE.Vector3(0, 0, 0),
    new THREE.Vector3(0.02, 0.04, -0.01),
    new THREE.Vector3(0.04, 0.22, -0.03),
    new THREE.Vector3(0.05, 0.42, -0.04),
    new THREE.Vector3(0.035, 0.58, -0.03),
    new THREE.Vector3(0.012, 0.66, -0.012),
  ]);
  const stick = new THREE.Mesh(new THREE.TubeGeometry(curve, 40, 0.0042, 8, false), mats.woodDark);
  stick.castShadow = true;
  g.add(stick);

  const hairPts = [
    new THREE.Vector3(0.002, 0.012, 0.01),
    new THREE.Vector3(0.018, 0.2, -0.002),
    new THREE.Vector3(0.028, 0.4, -0.008),
    new THREE.Vector3(0.02, 0.58, -0.004),
    new THREE.Vector3(0.004, 0.65, 0.004),
  ];
  const hair = new THREE.Mesh(new THREE.TubeGeometry(new THREE.CatmullRomCurve3(hairPts), 32, 0.0036, 6, false), mats.hair);
  g.add(hair);

  for (let i = 0; i < 9; i++) {
    const t = i / 8;
    const p = hairPts[0].clone().lerp(hairPts[hairPts.length - 1], t);
    const fiber = new THREE.Mesh(
      new THREE.TubeGeometry(
        new THREE.CatmullRomCurve3(hairPts.map((q) => q.clone().add(new THREE.Vector3((i - 4) * 0.0007, 0, (i - 4) * 0.0004)))),
        20,
        0.00035,
        4,
        false,
      ),
      mats.hair,
    );
    g.add(fiber);
    void p;
  }

  const wrap = new THREE.Mesh(new THREE.CylinderGeometry(0.0072, 0.0064, 0.09, 12), mats.wrap);
  wrap.position.set(0.012, 0.055, 0.002);
  wrap.rotation.z = 0.28;
  wrap.rotation.x = -0.2;
  wrap.castShadow = true;
  g.add(wrap);

  const frog = new THREE.Mesh(new THREE.BoxGeometry(0.014, 0.018, 0.01), mats.bone);
  frog.position.set(0.0, 0.008, 0.006);
  g.add(frog);

  const tip = new THREE.Mesh(new THREE.BoxGeometry(0.01, 0.014, 0.008), mats.bone);
  tip.position.set(0.01, 0.655, -0.008);
  g.add(tip);

  g.userData.restPosition = new THREE.Vector3(0.26, 0.05, 0.14);
  g.userData.restRotation = new THREE.Euler(-0.2, 0.85, 0.35);
  g.scale.setScalar(0.88);
  g.position.copy(g.userData.restPosition);
  g.rotation.copy(g.userData.restRotation);
  return g;
}

export function placeBowOnString(bow, stringPoint, tangent, energy = 0) {
  const p = stringPoint.clone();
  p.z += 0.01;
  p.x += 0.01;
  bow.position.lerp(p, 0.35);
  const look = p.clone().add(tangent);
  bow.lookAt(look);
  bow.rotateX(Math.PI * 0.5);
  bow.rotateZ(0.4 + Math.sin(energy * 12) * 0.04);
}
